export const PDF = 'application/pdf';
export const MS_WORD = 'application/msword';
export const WORD_DOCUMENT =
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
export const PLAIN_TEXT = 'text/plain';
export const RTF = 'application/rtf';
